export const hasFormDataAttributes = (formComponents) => {
  if (
    !formComponents ||
    !formComponents.components ||
    !Array.isArray(formComponents.components)
  ) {
    return false;
  }
  const dataComponents = formComponents.components.filter(
    (component) => component.key !== "submit" && component.type !== "button"
  );

  return dataComponents.length > 0;
};
